import React from "react";

import { connect } from "react-redux";
import { createUser, logOutUser } from "../actions/postAction";
import PropTypes from "prop-types";
import { Loading } from "./Loading";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Script from "react-load-script";
import { SITE_URL, BASE_URL } from "../constant";
import Loader from "react-loader-spinner";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { NetworkError } from "./NetworkError";
import {endpoints, http} from "../configs/https";

class MyQaideen extends React.Component {
  constructor() {
    super();
    this.state = {
      mydata: {},
      isLoaded: false,
      tajneed: false,
      atfal: false,
      etemad: false,
      tabligh: false,
      audit: false,
      ishaat: false,
      maal: false,
      taleem: false,
      waqar_amal: false,
      general: false,
      health: false,
      new_convert: false,
      social: false,
      student: false,
      tahrik: false,
      tarbiyya: false,
      trade: false,
      isLoading: false,
      modal: false,
      muqamiName: "",
      networkError: false
    };
    this.toggle = this.toggle.bind(this);

    this.fetchQaids = this.fetchQaids.bind(this);
    this.viewStatus = this.viewStatus.bind(this);
  }
  month_name(dt) {
    var mlist = [
      "",
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    return mlist[dt];
  }

  componentDidMount() {
    document.title = "My qaideens - MKAN REPORT";
    if (this.props.isLoggedIn) {
      axios
        .post(SITE_URL + "auth/verify/", { token: this.props.user.token })
        .then(res => {
          if (res.status === 200) {
            this.setState({});
            this.fetchQaids();
          } else {
            this.props.logOutUser();
          }
        })
        .catch(error => {
          if (error.message === "Network Error") {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            });
            this.setState({
              networkError: true,
              isLoaded: true
            });

            Toast.fire({
              type: "warning",
              title:
                "Network error, try Reloading page. Possibly no internet connection "
            });
          } else {
            if (error.response.status === 401) {
              this.props.logOutUser();
              window.location.replace("/");
              this.setState({});
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "error",
                title: "You need to log in again "
              });
            } else {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });
              this.setState({
                networkError: true,
                isLoaded: true
              });

              Toast.fire({
                type: "error",
                title: "Something went wrong, try again."
              });
            }
          }
        });
    }
  }
  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }
  viewStatus(id, name) {
    this.setState({
      muqamiName: name
    });
    this.fetchStatus(id);
  }
  fetchQaids() {
    const { month, year } = this.props.monthYear;
    http
      .post(
        endpoints.MY_QAIDEEN,
          { month: month, year: year },
      )
      .then(res => {
        //    if(res.status == 201){
        let wholeArray = Object.keys(res.data).map(key => res.data[key]);
        this.setState({
          isLoaded: true,
          mydata: wholeArray
        });

        //    }
      })
        .catch(error => {
          this.setState({
            isLoaded: true,
          });
          let errorMessage =
              (typeof error === "string" && error) ||
              "An error occured, please try again in a moment.";

          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          });

          Toast.fire({
            type: "error",
            title: errorMessage
          });
          // alert(JSON.stringify(error));
          console.log(errorMessage);
        });
  }

  fetchStatus(id) {
    const { month, year } = this.props.monthYear;
    this.setState({
      isLoading: true,
      modal: true
    });
    http
      .post(
        endpoints.QAID_STAT.replace(":id",id),
          { month: month, year: year },
      )
      .then(res => {
        this.setState({
          isLoading: false,
          tabligh: res.data.tabligh,
          tajneed: res.data.tajnid,
          etemad: res.data.secretariat,
          atfal: res.data.atfal,
          audit: res.data.audit,
          ishaat: res.data.ishaat,
          maal: res.data.maal,
          taleem: res.data.taleem,
          waqar_amal: res.data.waqar_amal,
          general: res.data.general,
          health: res.data.health,
          new_convert: res.data.new_convert,
          social: res.data.social,
          student: res.data.student,
          tahrik: res.data.tahrik,
          tarbiyya: res.data.tarbiyya,
          trade: res.data.trade
        });

        // console.log(this.state.mydata);
        // let wholeArray = Object.keys(res.data).map(key => res.data[key]);

        // console.log(wholeArray);
        // this.setState({
        //   isLoaded: true,
        //   mydata: wholeArray
        // });

        //    }
      })
        .catch(error => {
          this.setState({
            isLoading: false,
            modal:false,
          });
          let errorMessage =
              (typeof error === "string" && error) ||
              "An error occured, please try again in a moment.";

          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          });

          Toast.fire({
            type: "error",
            title: errorMessage
          });
          // alert(JSON.stringify(error));
          console.log(errorMessage);
        });
  }

  render() {
    var { isLoaded, mydata } = this.state;
    var i = 1;
    var d = new Date();
    var n = d.getFullYear();
    const { month, year } = this.props.monthYear;

    if (!isLoaded) {
      return (
        <div>
          <div className="spinner">
            <Loader type="ThreeDots" color="#00BFFF" height="40" width="40" />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          {this.state.networkError ? (
            <NetworkError />
          ) : (
            <section className="content">
              <div className="intro-section" id="home-section">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header card-header-icon card-header-rose">
                      <div className="card-icon">
                        <i className="material-icons">assignment</i>
                      </div>
                      <h4 className="card-title ">
                        View Report status of your
                        {this.props.user.dila ? " Muqami " : ""}
                        {this.props.user.state ? " Dila " : ""}
                        Qaideen for {this.month_name(month)} {year}
                      </h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table">
                          <thead className=" text-primary">
                            <tr>
                              <th>ID</th>
                              <th>Name</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {mydata.map(muqami => (
                              <tr key={muqami.name}>
                                <td>{i++}</td>
                                <td>{muqami.name}</td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                      this.viewStatus(muqami.id, muqami.name)
                                    }
                                  >
                                    <i className="fa fa-eye"></i> View
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <Modal
                  isOpen={this.state.modal}
                  toggle={this.toggle}
                  className={this.props.className}
                >
                  <ModalHeader toggle={this.toggle}>
                    Report submission status of
                    <b className="text-black"> {this.state.muqamiName}</b>
                  </ModalHeader>
                  <ModalBody>
                    {this.state.isLoading ? (
                      <div>
                        <div className="spinner">
                          <Loader
                            type="ThreeDots"
                            color="#00BFFF"
                            height="40"
                            width="40"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table">
                          <thead className=" text-primary">
                            <tr>
                              <th>ID</th>
                              <th>Report</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>Tabligh</td>
                              <td>
                                {" "}
                                {this.state.tabligh
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>

                            <tr>
                              <td>2</td>
                              <td>Atfal</td>
                              <td>
                                {" "}
                                {this.state.atfal
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>Tajneed</td>
                              <td>
                                {" "}
                                {this.state.tajneed
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>4</td>
                              <td>A'itmad</td>
                              <td>
                                {this.state.etemad
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>5</td>
                              <td>Muhasib</td>
                              <td>
                                {this.state.audit
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>6</td>
                              <td>Ishaat</td>
                              <td>
                                {this.state.ishaat
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>7</td>
                              <td>Maal</td>
                              <td>
                                {this.state.maal
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>8</td>
                              <td>Taleem</td>
                              <td>
                                {this.state.taleem
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>9</td>
                              <td>Waqar E mal</td>
                              <td>
                                {this.state.waqar_amal
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>10</td>
                              <td>Umoomi</td>
                              <td>
                                {this.state.general
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>11</td>
                              <td>Sehrat E Jismani</td>
                              <td>
                                {this.state.health
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>12</td>
                              <td>Nou-MUbayin</td>
                              <td>
                                {this.state.new_convert
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>13</td>
                              <td>Khidmat E Khalq</td>
                              <td>
                                {this.state.social
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>14</td>
                              <td>Umoor-e-Tulaba</td>
                              <td>
                                {this.state.student
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>15</td>
                              <td>Tahrik E Jadid</td>
                              <td>
                                {this.state.tahrik
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>16</td>
                              <td>Tarbiyyah</td>
                              <td>
                                {this.state.tarbiyya
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                            <tr>
                              <td>17</td>
                              <td>Sanat O Tijarat</td>
                              <td>
                                {this.state.trade
                                  ? "Submitted"
                                  : "Not submitted"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" onClick={this.toggle}>
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              </div>
            </section>
          )}
        </div>
      );
    }
  }
}

MyQaideen.propTypes = {
  createUser: PropTypes.func.isRequired,
  logOutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  user: state.person.user,
  isLoggedIn: state.person.isLoggedIn,
  monthYear: state.currentMonth.monthYear
});

export default connect(
  mapStateToProps,
  { createUser, logOutUser }
)(MyQaideen);
